interface RatingStarsProps {
  rating: number;
  size?: "sm" | "md";
}

export default function RatingStars({ rating, size = "sm" }: RatingStarsProps) {
  const full = Math.round(rating / 2);
  const text = size === "sm" ? "text-xs" : "text-sm";
  return (
    <span className={`inline-flex items-center gap-1 ${text} text-accent-500`}>
      {[0, 1, 2, 3, 4].map((i) => (
        <i
          key={i}
          className={i < full ? "ri-star-fill" : "ri-star-line opacity-40"}
        />
      ))}
      <span className="ml-0.5 font-semibold text-accent-600">{rating.toFixed(1)}</span>
    </span>
  );
}